import { Pipe, PipeTransform } from '@angular/core';

import {
    ConstantsService
} from '../core/upgraded-providers/constants';

@Pipe({
    name: 'powerName'
})
export class PowerNamePipe implements PipeTransform {

    public powers: any;

    constructor(
        private _CONSTANTS: ConstantsService
    ) {
        const {
            PWR_GENERATE_OPS,
            PWR_OPERATE_SPAWN,
            PWR_OPERATE_TOWER,
            PWR_OPERATE_STORAGE,
            PWR_OPERATE_LAB,
            PWR_OPERATE_EXTENSION,
            PWR_OPERATE_OBSERVER,
            PWR_OPERATE_TERMINAL,
            PWR_DISRUPT_SPAWN,
            PWR_DISRUPT_TOWER,
            PWR_DISRUPT_SOURCE,
            PWR_SHIELD,
            PWR_REGEN_SOURCE,
            PWR_REGEN_MINERAL,
            PWR_DISRUPT_TERMINAL,
            PWR_OPERATE_POWER,
            PWR_FORTIFY,
            PWR_OPERATE_CONTROLLER,
            PWR_OPERATE_FACTORY
        } = this._CONSTANTS;

        this.powers = Object.entries({
            PWR_GENERATE_OPS,
            PWR_OPERATE_SPAWN,
            PWR_OPERATE_TOWER,
            PWR_OPERATE_STORAGE,
            PWR_OPERATE_LAB,
            PWR_OPERATE_EXTENSION,
            PWR_OPERATE_OBSERVER,
            PWR_OPERATE_TERMINAL,
            PWR_DISRUPT_SPAWN,
            PWR_DISRUPT_TOWER,
            PWR_DISRUPT_SOURCE,
            PWR_SHIELD,
            PWR_REGEN_SOURCE,
            PWR_REGEN_MINERAL,
            PWR_DISRUPT_TERMINAL,
            PWR_OPERATE_POWER,
            PWR_FORTIFY,
            PWR_OPERATE_CONTROLLER,
            PWR_OPERATE_FACTORY
        });
    }

    transform(power: string): string {
        const [name] = this.powers.find(([name, value]) => {
            return value === parseInt(power, 10);
        });

        return name.replace('PWR_', '');
    }

}
